import { createFileRoute } from '@tanstack/react-router';
import { devicesQuery } from '@/features/devices/api';
import { DeviceConfigPage, type DeviceConfigSearch } from '@/features/devices/pages/DeviceConfigPage';

const str = (v: unknown) => (typeof v === 'string' && v ? v : undefined);

/**
 * "Qurilma konfiguratsiya" — devices table with filters (legacy 14:20124 restyled, 03-modules §4.8).
 * URL state: `?panel=new|<id>` device panel, `?view=<id>` detail modal.
 */
export const Route = createFileRoute('/_authed/t/$tenantSlug/_shell/devices/config')({
  validateSearch: (search: Record<string, unknown>): DeviceConfigSearch => ({ panel: str(search.panel), view: str(search.view) }),
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(devicesQuery(context.tenant.id));
  },
  component: DeviceConfigRoute,
});

function DeviceConfigRoute() {
  const { tenant } = Route.useRouteContext();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return <DeviceConfigPage tenant={tenant} search={search} onSearch={(next) => void navigate({ search: next })} />;
}
